<template>
  <div>
    <navHeader></navHeader>
      
<div class="container-lg mt-5">
       <div class="row border-bottom">
         <div class="col-lg-6 col-md-12 col-12">
        <div class="p-3">
      <h2 class="main-title">Archive</h2>
      <label>Stock reviews and market movements from earlier months will be archived here for reference.</label>
      </div>
         </div>
        <div class="col-lg-6 col-md-12 col-12">
          <div class="p-3 d-flex align-items-center justify-content-lg-end mt-lg-5">
              <date-picker class="date-picker" v-model="time3" range></date-picker>
              <button class="btn glob-btn">Search</button>
            </div> 
        </div>
      </div>


    <div class="archives"  v-for="(item, index) in generateList(KapitmansCornerArchive)[currentPage - 1]"
          :key="index">
        <div >
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="p-3">
            <h5>{{item.title}}</h5>
            <p class="text-muted m-0">Posted on {{FormatDate(item.date)}}</p>
             <div>
          <b-skeleton width="60%"></b-skeleton>
          <b-skeleton width="30%"></b-skeleton>
          </div>
          </div>
        </div>
      </div>

          <div class="row">
            <div class="col">
              <div class="p-3">
                <p class="text-muted" v-html="item.stockRecommendations.article"></p>
                <div>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
                <a href="javascript:void(0)" @click="ViewReport(item)">
                  Read full research <i class="bi bi-arrow-right"></i> 
                </a>
              </div>
            </div>
          </div>
          <hr />
        </div>
       
      </div>
       <div class="d-flex justify-content-center mt-5">
          <b-pagination
            size="lg"
            v-model="currentPage"
            :total-rows="generateList(KapitmansCornerArchive).length"
            :per-page="perPage"
            v-if="KapitmansCornerArchive.length > perPage"
          ></b-pagination>
        </div>
    </div>
     
      <hr />



  </div>
</template>

<script>
import navHeader from "../../NavHeader.vue";
import { mapState } from "vuex";
import moment from "moment";

//  import moment from "moment";

export default {
  components: {
    // Pagination,
    navHeader,
  },
  data() {
    return {
      perPage: 1,
      currentPage: 1,
    };
  },
  computed: {
    ...mapState({
      KapitmansCornerArchive: (state) => state.philstocksResearch.kapitmanArchive,
    }),

  
  },
  methods: {
     GoogleAnalytics() {
      this.$gtag.event("KapitsmanCornerArchive", { method: "Google" });
    },
    ViewReport(data) {
      this.$store.dispatch("philstocksResearch/SET_FullReport", data);
      this.$router.push("/KapitmansCorner/Archive/FullReport");
    },

    generateList(data) {
      var list = 5; // items per list
      var result = data.reduce((resultArray, item, index) => {
        const listIndex = Math.floor(index / list);
        if (!resultArray[listIndex]) {
          resultArray[listIndex] = []; // start a new list
        }
        resultArray[listIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },

    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    async GetKapitmanContent() {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetKapitsmanContent")
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },

  async mounted() {
    this.GetKapitmanContent();
    // this.$store.dispatch("philstocksResearch/GetReportsContent");
  },
};
</script>
<style></style>
